export default {
  'pages.workbenchDashboard.title': '超级软件工厂工作台',
  'pages.workbenchDashboard.subTitle':
    '汇总项目、资源与近期动态，快速了解整个超级软件工厂的运行状态。',
  'pages.workbenchDashboard.refresh': '刷新',
  'pages.workbenchDashboard.loadingError': '工作台数据加载失败，请稍后重试。',
  'pages.workbenchDashboard.partialStatsWarning':
    '部分项目代码统计未加载成功，当前总览基于已返回的数据计算。',
  'pages.workbenchDashboard.empty': '暂无可展示数据',
  'pages.workbenchDashboard.lastUpdatedAt': '更新时间',
  'pages.workbenchDashboard.kpi.projects': '项目总数',
  'pages.workbenchDashboard.kpi.activeProjects': '近 7 天活跃项目',
  'pages.workbenchDashboard.kpi.applications': '应用总数',
  'pages.workbenchDashboard.kpi.codebases': '代码仓库总数',
  'pages.workbenchDashboard.kpi.activeAgents': '活跃 Agent',
  'pages.workbenchDashboard.kpi.totalCodeLines': '代码总行数',
  'pages.workbenchDashboard.kpi.generatedCodeLines': 'AI 生成代码行数',
  'pages.workbenchDashboard.kpi.newCodeLines': '今日新增代码行数',
  'pages.workbenchDashboard.sections.groupDistribution': '项目分组分布',
  'pages.workbenchDashboard.sections.resourceComposition': '资源结构概览',
  'pages.workbenchDashboard.sections.activityTrend': '近 7 天平台动态趋势',
  'pages.workbenchDashboard.sections.projectSnapshot': '项目运行快照',
  'pages.workbenchDashboard.sections.recentLogs': '最近平台动态',
  'pages.workbenchDashboard.sections.riskBoard': '结构性风险提醒',
  'pages.workbenchDashboard.sections.quickActions': '快捷入口',
  'pages.workbenchDashboard.charts.group.unGrouped': '未分组',
  'pages.workbenchDashboard.charts.resource.projects': '项目',
  'pages.workbenchDashboard.charts.resource.applications': '应用',
  'pages.workbenchDashboard.charts.resource.codebases': '代码仓库',
  'pages.workbenchDashboard.charts.resource.activeAgents': '活跃 Agent',
  'pages.workbenchDashboard.risk.noApplications': '未建立应用的项目',
  'pages.workbenchDashboard.risk.noActiveAgents': '未绑定活跃 Agent 的项目',
  'pages.workbenchDashboard.risk.noRecentActivity': '14 天内无动态的项目',
  'pages.workbenchDashboard.risk.ok': '当前没有明显的结构性风险。',
  'pages.workbenchDashboard.table.project': '项目',
  'pages.workbenchDashboard.table.group': '分组',
  'pages.workbenchDashboard.table.apps': '应用',
  'pages.workbenchDashboard.table.agents': '活跃 Agent',
  'pages.workbenchDashboard.table.codeLines': '代码行数',
  'pages.workbenchDashboard.table.lastActivity': '最近动态',
  'pages.workbenchDashboard.quick.projects': '项目列表',
  'pages.workbenchDashboard.quick.devAgents': '开发 Agent 管理',
  'pages.workbenchDashboard.quick.estimationStandards': '工时评估标准',
  'pages.workbenchDashboard.log.empty': '最近暂无动态',
  'pages.workbenchDashboard.trend.totalOperations': '总操作数',
  'pages.workbenchDashboard.trend.failedOperations': '失败操作数',
};
